import React, { useContext, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import { PreliquidacionContext } from '../PreliquidacionContext';
import { currencyFormat, percentageFormat } from '../../../helpers/tableFormatters';
import CountUp from 'react-countup';
import GeneralConditionsModal from '../modals/GeneralConditionsModal';
import ButtonIcon from '../../../components/common/ButtonIcon';

const GeneralConditionsInfo = () => {
  const context = useContext(PreliquidacionContext);
  const { currentUser, liquidacion, loading, selected, handlePlanModal, handleUpdate } = context;

  const [editing, setEditing] = useState();

  const handleEdit = () => {
    setEditing(true);
  }

  const onEdit = (data) => {
    handleUpdate(data);
  }

  return (
    <>
    {editing && (
      <GeneralConditionsModal 
        open={editing}
        data={selected}
        title="Edición Condiciones Generales"
        toggle={() => setEditing(!editing)} 
        handleUpdate={onEdit}
        currentUser={currentUser}
      />
    )}
    <Card className={`my-3`} >
      <FalconCardHeader title="Condiciones Generales">
      {!liquidacion && (
        <ButtonIcon onClick={handleEdit} icon={faEdit} transform="shrink-3 down-2" color="falcon-default" size="sm" className="mr-2">
          Editar
        </ButtonIcon>
      )}
      </FalconCardHeader>
      <CardBody className="bg-light border-top px-4">
        {!loading && selected ? (
        <Row className="text-right fs-3">
          <Col lg={12}>
            <DetailRow textNormal title="Monto Solicitado">{selected.monto ? currencyFormat(selected.monto) : <span className='p-2'></span>}</DetailRow>
            <DetailRow textNormal title="Tasa de Interés">
              {selected.tasa ? percentageFormat(selected.tasa) : <span className='p-2'></span>}
            </DetailRow>
            <DetailRow textNormal title="Plazo en Meses" childrenClasses="uppercase">
              {selected.plazo || <span className='p-2'></span>}
            </DetailRow>
            <DetailRow textNormal title="Tipo de Fórmula" childrenClasses="uppercase">
              {selected.nomTipoFormula || <span className='p-2'></span>}
            </DetailRow>
            <DetailRow textNormal title="Porcentaje Prima" childrenClasses="uppercase">
              {selected.tasaPrima ? percentageFormat(selected.tasaPrima) : <span className='p-2'></span>}
            </DetailRow>
            <DetailRow textNormal title="Valor Prima" childrenClasses="uppercase">
              {selected.valorPrima ? currencyFormat(selected.valorPrima) :<span className='p-2'></span>}
            </DetailRow>
            <DetailRow textNormal title="Fecha de Primer Corte" childrenClasses="uppercase">
              {selected.fechaCorte ? selected.fechaCorte :<span className='p-2'></span>}
            </DetailRow>
            <DetailRow textNormal title="Cuota Mensual" childrenClasses="text-primary fs-5">
              <CountUp end={selected.valorCuota || 0} duration={1} prefix="$" separator="." decimal="," decimals={2} />
              <div>
              <a className="font-weight-semi-bold fs--1 text-nowrap cursor-pointer" onClick={() => handlePlanModal(true)}>
                Ver Plan de Pagos
                <FontAwesomeIcon icon="angle-right" transform="down-1.5" className="ml-1" />
              </a>
              </div>
            </DetailRow>
          </Col>
        </Row>
        ) : <></>}
      </CardBody>
    </Card>
    </>
  );
};

export default GeneralConditionsInfo;
